import { render, staticRenderFns } from "./AddInsurers.vue?vue&type=template&id=65656104&scoped=true"
import script from "./AddInsurers.vue?vue&type=script&lang=js"
export * from "./AddInsurers.vue?vue&type=script&lang=js"
import style0 from "./AddInsurers.vue?vue&type=style&index=0&id=65656104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65656104",
  null
  
)

export default component.exports